module.exports = __webpack_public_path__ + "img/committee.9fa11964.png";